const { validate: uuidValidate } = require('uuid');

const class2type = {};

const types = [
  'Boolean',
  'Number',
  'String',
  'Function',
  'Array',
  'Date',
  'RegExp',
  'Object',
];

const toStr = Object.prototype.toString;

types.forEach(name => {
  class2type[`[object ${name}]`] = name.toLowerCase();
});

const typeOf = obj => {
  if (typeof obj === 'undefined') {
    return 'undefined';
  }

  return obj === null ? String(obj) : class2type[toStr.call(obj)] || 'object';
};

export const isBoolean = arg => typeOf(arg) === 'boolean';
export const isNum = arg => typeOf(arg) === 'number';
export const isString = arg => typeOf(arg) === 'string';
export const isFunction = arg => typeOf(arg) === 'function';
export const isArray = arg => typeOf(arg) === 'array';
export const isDate = arg => typeOf(arg) === 'date';
export const isRegExp = arg => typeOf(arg) === 'regexp';
export const isObject = arg => typeOf(arg) === 'object';
export const isNumber = arg => isNum(arg) && !isNaN(arg);
export const isInteger = arg => isNumber(arg) && Number.isInteger(arg);
export const isUUID = arg => uuidValidate(arg);
